import { Link } from 'react-router-dom'
import { Button, Dropdown } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import Search from '../../components/SearchFilter'
import TableAntd from '../../components/TableAntd'
import useHook from './hooks'
import style from './style.module.scss'
import Buttonbar from '../../components/ButtonBar'
import CustomModal from '../../components/ModalUser'
import Stockimport from './components/stockimport'
import { history } from '../../redux/store'
import { fillingStateList } from '../../components/SearchFilter/TemplateData'
const operationMenuList = ['客户订单报备', '商品报备'] as const
export type RegistryAddType = (typeof operationMenuList)[number]
export default function ReturnManagement() {
  const {
    dateSource,
    isTableLoading,
    pagination,
    importVisible,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
    onImportContract,
    onCancelModel,
    handleTableChangeCheck,
    handleOperationMenuClick,
    // 5.9.1版本暂时隐藏
    // onDwonload,
    // onImportData,
    // onExportData,
  } = useHook()

  const orderDetailLinkRender = (text: any, record: any) => {
    return (
      <Button
        type="link"
        onClick={() => {
          history.replace({
            pathname: `/srm/${
              record.filingType === '商品报备'
                ? 'filingSheetDetail'
                : 'reportReceiptDetail'
            }`,
            state: {
              id: record.id,
            },
          })
        }}
      >
        {text}
      </Button>
    )
  }

  const items = operationMenuList.map((item) => ({
    label: item,
    key: item,
  }))

  const listColumnDict: any = {
    报备管理: {
      listColumn: [
        {
          key: 'filingNo',
          dataIndex: 'filingNo',
          title: '报备单号',
          render: orderDetailLinkRender,
        },
        {
          key: 'state',
          dataIndex: 'state',
          title: '报备单状态',
          render: (text: string) => {
            return (
              <span>
                {fillingStateList.find((item) => item.id === text)?.name}
              </span>
            )
          },
        },
        {
          key: 'orderNo',
          dataIndex: 'orderNo',
          title: '客户订单号',
        },
        {
          key: 'price',
          dataIndex: 'price',
          title: '报备金额',
        },
        {
          key: 'platform',
          dataIndex: 'platform',
          title: '平台',
        },
        {
          key: 'customer',
          dataIndex: 'customer',
          title: '客户名称',
        },
        {
          key: 'validity',
          dataIndex: 'validity',
          title: '报备有效期',
        },
        {
          key: 'filingType',
          dataIndex: 'filingType',
          title: '报备类型',
        },
        {
          key: 'filingTime',
          dataIndex: 'filingTime',
          title: '报备时间',
        },
      ],
    },
  }

  // 5.9.1版本暂时隐藏
  // const menu = (
  //   <Menu>
  //     <Menu.Item key="import" onClick={onImportData}>
  //       导入
  //     </Menu.Item>
  //     <Menu.Item key="export" onClick={onExportData}>
  //       导出
  //     </Menu.Item>
  //     <Menu.Item key="template" onClick={onDwonload}>
  //       模板
  //     </Menu.Item>
  //   </Menu>
  // )

  return (
    <div>
      <Search
        fieldsData={[
          'filingNo',
          'fillingState',
          'orderNo',
          'price',
          'platform',
          'customer',
          'filingArriveStartTime',
          'filingArriveEndTime',
          'filingType',
          'filingStartTime',
          'filingEndTime',
        ]}
        onSearch={handleSearchClick}
        keyName="ORDERREGISTRATION"
        ScreenKey="ORDERREGISTRATION"
      />
      <div className={style['inner-content']}>
        <div className={style['tab-container']}>
          {/* 5.9.1版本暂时隐藏 */}
          {/* <Dropdown overlay={menu}>
            <Button style={{ marginRight: 10 }}>
              <Space>
                数据
                <DownOutlined />
              </Space>
            </Button>
          </Dropdown> */}
          <Dropdown menu={{ items, onClick: handleOperationMenuClick }}>
            <Button type="primary">
              新建 <DownOutlined />
            </Button>
          </Dropdown>
        </div>
        <Buttonbar onRefresh={handleTableRefresh}></Buttonbar>
        <TableAntd
          dataSource={dateSource}
          listColumn={listColumnDict['报备管理'].listColumn}
          loading={isTableLoading}
          Y={340}
          pagination={{
            ...pagination,
            onChange: handlePaginationChange,
          }}
          showSize
          onChangeCheck={handleTableChangeCheck}
        ></TableAntd>
        <CustomModal
          title="导入"
          open={importVisible}
          modalCancel={onCancelModel}
          width={400}
          footer={false}
        >
          {importVisible ? (
            <Stockimport onUploadfile={onImportContract} />
          ) : null}
        </CustomModal>
      </div>
    </div>
  )
}
import { Link } from 'react-router-dom'
import { Button, Dropdown } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import Search from '../../components/SearchFilter'
import TableAntd from '../../components/TableAntd'
import useHook from './hooks'
import style from './style.module.scss'
import Buttonbar from '../../components/ButtonBar'
import CustomModal from '../../components/ModalUser'
import Stockimport from './components/stockimport'
import { history } from '../../redux/store'
import { fillingStateList } from '../../components/SearchFilter/TemplateData'
const operationMenuList = ['客户订单报备', '商品报备'] as const
export type RegistryAddType = (typeof operationMenuList)[number]
export default function ReturnManagement() {
  const {
    dateSource,
    isTableLoading,
    pagination,
    importVisible,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
    onImportContract,
    onCancelModel,
    handleTableChangeCheck,
    handleOperationMenuClick,
    // 5.9.1版本暂时隐藏
    // onDwonload,
    // onImportData,
    // onExportData,
  } = useHook()

  const orderDetailLinkRender = (text: any, record: any) => {
    return (
      <Button
        type="link"
        onClick={() => {
          history.replace({
            pathname: `/srm/${
              record.filingType === '商品报备'
                ? 'filingSheetDetail'
                : 'reportReceiptDetail'
            }`,
            state: {
              id: record.id,
            },
          })
        }}
      >
        {text}
      </Button>
    )
  }

  const items = operationMenuList.map((item) => ({
    label: item,
    key: item,
  }))

  const listColumnDict: any = {
    报备管理: {
      listColumn: [
        {
          key: 'filingNo',
          dataIndex: 'filingNo',
          title: '报备单号',
          render: orderDetailLinkRender,
        },
        {
          key: 'state',
          dataIndex: 'state',
          title: '报备单状态',
          render: (text: string) => {
            return (
              <span>
                {fillingStateList.find((item) => item.id === text)?.name}
              </span>
            )
          },
        },
        {
          key: 'orderNo',
          dataIndex: 'orderNo',
          title: '客户订单号',
        },
        {
          key: 'price',
          dataIndex: 'price',
          title: '报备金额',
        },
        {
          key: 'platform',
          dataIndex: 'platform',
          title: '平台',
        },
        {
          key: 'customer',
          dataIndex: 'customer',
          title: '客户名称',
        },
        {
          key: 'validity',
          dataIndex: 'validity',
          title: '报备有效期',
        },
        {
          key: 'filingType',
          dataIndex: 'filingType',
          title: '报备类型',
        },
        {
          key: 'filingTime',
          dataIndex: 'filingTime',
          title: '报备时间',
        },
      ],
    },
  }

  // 5.9.1版本暂时隐藏
  // const menu = (
  //   <Menu>
  //     <Menu.Item key="import" onClick={onImportData}>
  //       导入
  //     </Menu.Item>
  //     <Menu.Item key="export" onClick={onExportData}>
  //       导出
  //     </Menu.Item>
  //     <Menu.Item key="template" onClick={onDwonload}>
  //       模板
  //     </Menu.Item>
  //   </Menu>
  // )

  return (
    <div>
      <Search
        fieldsData={[
          'filingNo',
          'fillingState',
          'orderNo',
          'price',
          'platform',
          'customer',
          'filingArriveStartTime',
          'filingArriveEndTime',
          'filingType',
          'filingStartTime',
          'filingEndTime',
        ]}
        onSearch={handleSearchClick}
        keyName="ORDERREGISTRATION"
        ScreenKey="ORDERREGISTRATION"
      />
      <div className={style['inner-content']}>
        <div className={style['tab-container']}>
          {/* 5.9.1版本暂时隐藏 */}
          {/* <Dropdown overlay={menu}>
            <Button style={{ marginRight: 10 }}>
              <Space>
                数据
                <DownOutlined />
              </Space>
            </Button>
          </Dropdown> */}
          <Dropdown menu={{ items, onClick: handleOperationMenuClick }}>
            <Button type="primary">
              新建 <DownOutlined />
            </Button>
          </Dropdown>
        </div>
        <Buttonbar onRefresh={handleTableRefresh}></Buttonbar>
        <TableAntd
          dataSource={dateSource}
          listColumn={listColumnDict['报备管理'].listColumn}
          loading={isTableLoading}
          Y={340}
          pagination={{
            ...pagination,
            onChange: handlePaginationChange,
          }}
          showSize
          onChangeCheck={handleTableChangeCheck}
        ></TableAntd>
        <CustomModal
          title="导入"
          open={importVisible}
          modalCancel={onCancelModel}
          width={400}
          footer={false}
        >
          {importVisible ? (
            <Stockimport onUploadfile={onImportContract} />
          ) : null}
        </CustomModal>
      </div>
    </div>
  )
}
